import React from "react";

import ExperienceIllustration from "../../../assets/illustrations/experience.svg";
import Timeline from "../../common/timeline/Timeline";

import experience from "../../../assets/data/experience.json";

import "./workExperience.scss";

const WorkExperience = () => {
    return (
        <div className="flexContainer workExperienceContainer">
            <div className="timelineContainer p-8">
                <Timeline data={experience.experiences} />
            </div>
            <div className="experienceIllustraion flexContainer centerAlign p-8">
                <img
                    className="experienceIllustraionSVG"
                    src={ExperienceIllustration}
                    alt="Experience Illustration"
                />
            </div>
        </div>
    );
};

export default WorkExperience;
